import { render, staticRenderFns } from "./productDisplay.vue?vue&type=template&id=b41c3a02&"
import script from "./productDisplay.vue?vue&type=script&lang=js&"
export * from "./productDisplay.vue?vue&type=script&lang=js&"
import style0 from "./productDisplay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports